import config from "../config";

const store = {
	state: {
		title: config.title,
		desc: config.desc,
		search: "",

		file: null,
		fileName: null,

		mode: localStorage.getItem("mode") || "cover",

		transparent: JSON.parse(localStorage.getItem("transparent")) || false,

		backgroundColors: JSON.parse(localStorage.getItem("backgroundColors")) || {
			hex: "#F5F5F5",
			rgba: {a: 1, b: 245, g: 245, r: 245}
		},

		subscribe: false,

		offsetTop: 0
	},

	setBackgroundColors(data) {
		this.state.backgroundColors = data;
		localStorage.setItem("backgroundColors", JSON.stringify(data));
	},

	setTransparent(bool) {
		this.state.transparent = bool;
		localStorage.setItem("transparent", bool);
	},

	backgroundColorRgba() {
		if (this.state.transparent) return "transparent";
		const c = this.state.backgroundColors.rgba;
		return `rgba(${c.r}, ${c.g}, ${c.b}, ${c.a})`;
	},

	page(title) {
		const text = title ? `${title} - ${this.state.title}` : this.state.title;
		document.title = text;
		document
			.querySelector('meta[property="og:title"]')
			.setAttribute("content", text);
	},

	desc(desc) {
		const text = desc ? desc : this.state.desc;
		document
			.querySelector('meta[name="description"]')
			.setAttribute("content", text);
		document
			.querySelector('meta[property="og:description"]')
			.setAttribute("content", text);
	},

	setMode(mode) {
		this.state.mode = mode;
		localStorage.setItem("mode", mode);
	}
};

(() => {
	if (typeof window === "undefined") return;

	window.addEventListener("scroll", () => {
		store.state.offsetTop = window.pageYOffset;
	});
})();

export default store;
